module.exports = __webpack_public_path__ + "img/icons-filter.311ccb69.svg";